import { post } from 'lib/request'

export type DeviceInfo = {
  userAgent: string
  platform: string
  browser: {
    name: string
    version: string
  }
  screen: {
    width: number
    height: number
    colorDepth: number
  }
  window: {
    width: number
    height: number
  }
  language: string
  timezone: string
  cookiesEnabled: boolean
  javaEnabled: boolean
  online: boolean
  referrer: string
}

const REACT_APP_API_URL = process.env.REACT_APP_API_URL

/**
 * Saves user device information to the server.
 *
 * @param url An object containing device information.
 * @returns A promise indicating the success of the operation.
 */
export const saveUserDeviceInfo = async (url: DeviceInfo) =>
  post(`${REACT_APP_API_URL}device/saveUserDeviceData`, url)
